import { render, staticRenderFns } from "./ReturnTop.vue?vue&type=template&id=9b69476a&scoped=true&"
import script from "./ReturnTop.vue?vue&type=script&lang=js&"
export * from "./ReturnTop.vue?vue&type=script&lang=js&"
import style0 from "./ReturnTop.vue?vue&type=style&index=0&id=9b69476a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b69476a",
  null
  
)

export default component.exports